import { render, staticRenderFns } from "./SiteTemplateAnswers.vue?vue&type=template&id=aa08cc10"
import script from "./SiteTemplateAnswers.vue?vue&type=script&lang=js"
export * from "./SiteTemplateAnswers.vue?vue&type=script&lang=js"
import style0 from "./SiteTemplateAnswers.vue?vue&type=style&index=0&id=aa08cc10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports